/**
 * @param onClick {() => void}
 * @returns {void}
 */
module.exports = function listenForForm1262ReturningUserNotYouClicks(onClick) {
    document.querySelectorAll('[data-component="form-1262-returning-user-not-you-button"]').forEach(notYouButton => {
        notYouButton.addEventListener('click', ev => {
            ev.preventDefault();
            onClick();
        });
    });
}